export enum NotificationsEventTypes {
    LOAD = 'LOAD',
    INTERACT = 'INTERACT',
    DISMISS = 'DISMISS',
    SUCCESS = 'SUCCESS',
}
